<template>
    <div class="pager-control">
        Afficher
        <div class="dropdown" :class="{ open: isOpen }" @click="isOpen = !isOpen">
            <div class="dropdown-toggle">
                {{ value.pageSize }}
                <font-awesome-icon icon="caret-down" class="icon" />
            </div>
            <ul v-if="isOpen" class="dropdown-menu">
                <li
                    v-for="option in options"
                    :key="option.id"
                    :value="option"
                    :selected="option === value.pageSize"
                    @click="handleSelection"
                >
                    {{ option }}
                </li>
            </ul>
        </div>
        résultats
        <div class="pagination">
            <font-awesome-icon
                v-show="!firstPage"
                icon="angle-double-left"
                class="icon"
                @click="goToFirstPage"
            />
            <font-awesome-icon
                v-show="!firstPage"
                icon="angle-left"
                class="icon"
                @click="prevPage"
            />
            <span
                class="page"
                :class="{ current: page === value.pageNumber, 'text-only': page === '...' }"
                v-for="page in firstPages"
                :key="page"
                @click="goToPage(page)"
            >
                {{ page }}
            </span>
            <font-awesome-icon
                v-show="!lastPage"
                icon="angle-right"
                class="icon"
                @click="nextPage"
            />
            <font-awesome-icon
                v-show="!lastPage"
                icon="angle-double-right"
                class="icon"
                @click="goToLastPage"
            />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        length: {
            type: Number,
            default: 0,
        },
        value: {
            type: Object,
            default: () => ({
                pageSize: null,
                pageNumber: null,
            }),
        },
    },
    data: () => {
        return {
            isOpen: false,
            firstPages: [],
            // const injection
            options: [12, 24, 48],
            DEAFULT_PAGE_SIZE: 24,
        };
    },
    watch: {
        value(val, old) {
            this.updateRank(val.pageSize !== old.pageSize);
        },
        length() {
            this.updateRank(true);
        },
    },
    mounted() {
        this.updateRank();
        // send initial values
        this.$emit('input', {
            pageSize: this.DEAFULT_PAGE_SIZE,
            pageNumber: 1,
        });
    },
    computed: {
        firstPage() {
            // 0 case
            return this.value.pageNumber < 2;
        },
        lastPage() {
            const pageNumber = Math.ceil(this.length / this.value.pageSize);
            return this.value.pageNumber === pageNumber;
        },
    },
    methods: {
        handleSelection(event) {
            this.$emit('input', {
                pageSize: event.target.value,
                pageNumber: this.value.pageNumber,
            });
            this.$nextTick(() => (this.isOpen = false));
        },
        goToFirstPage() {
            this.$emit('input', {
                ...this.value,
                pageNumber: 1,
            });
        },
        goToLastPage() {
            const pageNumber = Math.ceil(this.length / this.value.pageSize);
            this.$emit('input', {
                ...this.value,
                pageNumber: pageNumber,
            });
        },
        prevPage() {
            // this.updateRank();
            this.$emit('input', {
                ...this.value,
                pageNumber: this.value.pageNumber - 1,
            });
        },
        nextPage() {
            // this.updateRank();
            this.$emit('input', {
                ...this.value,
                pageNumber: this.value.pageNumber + 1,
            });
        },
        goToPage(page) {
            if (page === '...') {
                return;
            }
            this.$emit('input', {
                ...this.value,
                pageNumber: page,
            });
        },
        updateRank(force) {
            const currentPage = this.value.pageNumber;
            if (!currentPage || (this.firstPages.includes(currentPage) && !force)) {
                return;
            }

            const maxPages = Math.ceil(this.length / this.value.pageSize);
            // if page outside range
            if (currentPage > maxPages) {
                this.$emit('input', {
                    ...this.value,
                    pageNumber: 1,
                });
                return;
            }

            const makeArray = (length, offset) =>
                Array.apply(null, Array(length)).map((_, i) => offset + i);

            const ELLIPSIS_MIN_RANGE = 2;
            const ITEM_RANGE = 6;
            if (maxPages <= ITEM_RANGE) {
                this.firstPages = makeArray(maxPages, currentPage);
                return;
            }
            if (currentPage < maxPages - ELLIPSIS_MIN_RANGE - 1) {
                this.firstPages = [
                    ...makeArray(ITEM_RANGE - ELLIPSIS_MIN_RANGE, currentPage),
                    '...',
                    maxPages,
                ];
                return;
            }
            this.firstPages = [1, '...', ...makeArray(maxPages - currentPage + 1, currentPage)];
        },
    },
};
</script>

<style lang="scss">
.pager-control {
    // force row wrap
    margin: 10px 0.25em;
    color: #1f2f3c;
    font-size: 14px;
    line-height: 19px;
    // force height to 3+#option em
    min-height: 6em;

    @media screen and (min-width: 20em) {
        flex: 0 1 calc(132% - 1em);
    }
    @media screen and (min-width: 40em) {
        flex: 0 1 calc(100% - 1em);
    }
    @media screen and (min-width: 60em) {
        flex: 0 1 calc(99% - 1em);
    }

    // .pager--size {}
    .dropdown {
        border: 1px solid #c3c3c3;
        border-radius: 5px;
        color: #1f2f3c;
        transition: all 0.25s ease-in-out;
        font-size: 14px;
        position: relative;
        display: inline-block;

        &.open .dropdown-toggle {
            // color: #3b3e47;
            color: #1f2f3c;
            z-index: 9999;
        }

        .dropdown-toggle {
            margin: 4px 7px;

            .icon {
                padding: 0 1px;
            }
        }

        .dropdown-menu {
            position: absolute;
            left: 0;
            right: 0;
            border: 1px solid #8e919b;
            border-radius: 7px;
            background-color: #ffffff;
            box-shadow: 0 0 7px 2px rgba(241, 241, 241, 0.5);
            margin-top: 1px;
            padding: 4px 6px;

            .scroller {
                overflow: auto;
                height: 94px;
            }
        }
    }

    .pagination {
        float: right;

        .icon {
            cursor: pointer;
        }

        span.page {
            height: 26px;
            width: 26px;
            border-radius: 4px;
            color: #151b25;
            // font-family: Avenir;
            font-size: 16px;
            line-height: 22px;
            margin: 0 5px;
            display: inline-flex;
            align-items: center;
            justify-content: center;

            &:not(.text-only) {
                cursor: pointer;
            }

            &.current {
                background-color: #6c3e91;
                color: #ffffff;
            }
        }
    }
}
</style>
